var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('roles.userRoles'),"description":_vm.$t('roles.fromHereYouCanControlTheUsersPermissions')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('roles.SearchForAGroup'),"emptyTableText":_vm.$t('roles.thereAreNoRoles'),"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"buttonRole":_vm.$user.role.roles_add,"cloumns":[
          {
            column: 'name',
            title: _vm.$t('roles.name'),
            type: 'text',
            sort: true
          },
          {
            column: 'users_count',
            title: _vm.$t('roles.usersCount'),
            type: 'text'
          },
          {
            column: 'options',
            title: _vm.$t('roles.settings'),
            type: 'options',
            options: [
              { name: 'edit', role: _vm.$user.admin || _vm.$user.role.roles_edit },
              {
                name: 'delete',
                role: _vm.$user.admin || _vm.$user.role.roles_delete
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }